import React from 'react';
import * as RadixTabsPrimitive from '@radix-ui/react-tabs';
import {
  styled,
  GDSCustomizableComponent,
  GDSResponsiveProp,
  Tabs,
  GenesisCoreInspector,
} from '@leagueplatform/genesis-core';

export interface GDSSegmentedTabListProps
  extends RadixTabsPrimitive.TabsListProps,
    GDSCustomizableComponent {
  divider?: boolean;
  tabDistribution?: GDSResponsiveProp<'distributeEvenly' | 'hugContents'>;
}

const DISPLAY_NAME = 'SegmentControlList';
const MAX_CHILDREN = 4;

export const BaseSegmentedTabList = styled(Tabs.TabList, {
  width: 'fit-content',
  backgroundColor: '$surfaceBackgroundPrimary',
  border: '1px solid $onSurfaceBorderSubdued',
  borderRadius: '$pill',
  padding: '$half',
  boxShadow: '$card',
});

export const List: React.FC<GDSSegmentedTabListProps> = ({
  className,
  children,
  'data-testid': testId = `GDS-${DISPLAY_NAME}`,
  ...props
}) => {
  if (!children || React.Children.count(children) > MAX_CHILDREN) {
    console.warn(
      `There must be at least 1 but no more than ${MAX_CHILDREN} segments.`,
    );
  }

  const firstChildren = React.Children.toArray(children).slice(0, MAX_CHILDREN);

  return (
    <GenesisCoreInspector displayName={DISPLAY_NAME}>
      <BaseSegmentedTabList
        data-testid={testId}
        className={[`GDS-segment-control-button-list`, className].join(' ')}
        {...props}
      >
        {firstChildren}
      </BaseSegmentedTabList>
    </GenesisCoreInspector>
  );
};
